import type { RouteRecordRaw } from 'vue-router'

const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: '/admin/tenant',
    children: [
      {
        path: 'tenant',
        name: 'admin-tenant',
        component: () => import('@/views/admin/TenantInfo.vue'),
        meta: { title: '租户管理' }
      },
      {
        path: 'department',
        name: 'admin-department',
        component: () => import('@/views/admin/DepartmentList.vue'),
        meta: { title: '部门管理' }
      },
      {
        path: 'user',
        name: 'admin-user',
        component: () => import('@/views/admin/UserList.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'audits',
        name: 'audits',
        component: () => import('@/views/admin/AuditList.vue'),
        meta: { title: '审计日志' }
      },
      {
        path: 'roles',
        name: 'admin-roles',
        component: () => import('@/views/admin/RoleList.vue'),
        meta: { title: '角色管理', permission: 'role:view' }
      },
      {
        path: 'permissions',
        name: 'admin-permissions',
        component: () => import('@/views/admin/PermissionAssign.vue'),
        meta: { title: '权限分配', permission: 'role:view' }
      },
      {
        path: 'dict',
        name: 'admin-dict',
        component: () => import('@/views/admin/DictManagement.vue'),
        meta: { title: '字典管理', permission: 'dict:view' }
      },
      {
        path: 'positions',
        name: 'admin-positions',
        component: () => import('@/views/admin/PositionManagement.vue'),
        meta: { title: '岗位库管理', permission: 'position:view' }
      },
      {
        path: 'department-positions',
        name: 'admin-department-positions',
        component: () => import('@/views/admin/DepartmentPositionManagement.vue'),
        meta: { title: '部门岗位管理', permission: 'department_position:view' }
      },
      {
        path: 'im',
        name: 'admin-im',
        component: () => import('@/views/admin/ImSettings.vue'),
        meta: { title: 'IM 集成', permission: 'im:view' }
      },
      {
        path: 'org-integration',
        name: 'admin-org-integration',
        component: () => import('@/views/admin/OrgIntegration.vue'),
        meta: { title: '组织同步', permission: 'integration:external-directory:view' }
      }
    ]
  }
]

export default adminRoutes
